import React, { Component } from "react";
import {
    Grid,
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
    Table,
} from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import queryString from "query-string";

import AreaTable from "./AreaTable.jsx";
import AttendanceTable from "./AttendanceTable.jsx";
import AttendanceRuleTable from "./AttendanceRuleTable.jsx";
import CompanyTable from "./CompanyTable.jsx";
import DepartmentTable from "./DepartmentTable.jsx";
import EmployeeTypeTable from "./EmployeeTypeTable.jsx";
import HolidaysTable from "./HolidaysTable.jsx";
import PagIbigTable from "./PagIbigTable.jsx";
import PayscaleTable from "./PayscaleTable.jsx";
import PerformanceTable from "./PerformanceTable.jsx";
import PHICTable from "./PHICTable.jsx";
import PositionTable from "./PositionTable.jsx";
import SSSTable from "./SSSTable.jsx";
import IncomeTaxTable from "./IncomeTaxTable.jsx";
import PayLevelTable from "./PayLevelTable.jsx";

import { areaSelectOptionRequest } from "../../../api/area";
import { handleAttendanceCSVRequest } from "../../../api/attendance";
import { getEffectiveDateList as getSSSEffectiveDateList } from "api/sss";
import { getEffectiveDateList as getPhicsEffectiveDateList } from "api/phic";
import { getEffectiveDateList as getPagIbigEffectiveDateList } from "api/pagIbig";
import { getEffectiveDateList as getIncomeTaxEffectiveDateList } from "api/incomeTax";
import { getEffectiveDateList as getPayscaleEffectiveDateList } from "api/payscale";
import { getFullName } from "../../../helpers/functions/employee";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect.jsx";

const attendanceCsvKeys = ["Date/Time", "Status", "ID Number"];

const parseCSVLine = (line) => {
    const values = [];
    let value = "";
    let insideQuotes = false;

    for (let i = 0; i < line.length; i++) {
        const character = line[i];
        const nextCharacter = line[i + 1];

        if (character === '"' && insideQuotes && nextCharacter === '"') {
            value += '"';
            i++;
        } else if (character === '"') {
            insideQuotes = !insideQuotes;
        } else if (character === "," && !insideQuotes) {
            values.push(value.trim());
            value = "";
        } else {
            value += character;
        }
    }

    values.push(value.trim());

    return values;
};

const parseAttendanceCSV = (csvText) => {
    const lines = csvText
        .replace(/^\uFEFF/, "")
        .split(/\r?\n/)
        .filter((line) => line.trim());

    if (!lines.length) return [];

    const firstRow = parseCSVLine(lines[0]);
    const hasHeader = attendanceCsvKeys.every((key) => firstRow.includes(key));
    const header = hasHeader ? firstRow : attendanceCsvKeys;
    const dataLines = hasHeader ? lines.slice(1) : lines;

    return dataLines.map((line) => {
        const values = parseCSVLine(line);

        return attendanceCsvKeys.reduce((attendanceInput, key, index) => {
            const valueIndex = hasHeader ? header.indexOf(key) : index;
            attendanceInput[key] =
                valueIndex >= 0 && values[valueIndex] !== undefined
                    ? values[valueIndex]
                    : "";

            return attendanceInput;
        }, {});
    });
};

class DatabaseList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedTable: "",
            selectedEmployee: "",
            selectedLocation: "",
            selectedEffectiveDate: "",
            employeeSelectOptions: [],
            areaSelectOptions: [],
            error: null,
            attendanceBulkResult: null,
            attendanceBulkSuccess: false,
            attendanceBulkLoading: false,
            effectiveDateList: [],
            selectedAttendanceDate: null,
        };
    }

    async componentDidMount() {
        const { match, location } = this.props;
        const searchParams = queryString.parse(location.search);

        if (match.params.collection) {
            //TODO: Move this switch to a helper function
            let selectedTable;
            let selectedEmployee;
            let selectedLocation;
            let selectedEffectiveDate;
            let selectedAttendanceDate;

            switch (match.params.collection) {
                case "area":
                    selectedTable = "area";
                    break;
                case "attendance":
                    selectedTable = "attendance";
                    selectedEmployee = searchParams.employee;
                    selectedAttendanceDate = searchParams.date;
                    // employeeSelectOptionRequest(
                    //     (result) =>
                    //         this.setState({ employeeSelectOptions: result }),
                    //     (error) =>
                    //         this.setState({ error: "There was an error" }),
                    // );
                    break;
                case "attendance-rule":
                    selectedTable = "attendance-rule";
                    break;
                case "pay-level":
                    selectedTable = "pay-level";
                    break;
                case "company":
                    selectedTable = "company";
                    break;
                case "department":
                    selectedTable = "department";
                    break;
                case "employee-type":
                    selectedTable = "employee-type";
                    break;
                case "holidays":
                    selectedTable = "holidays";
                    if (searchParams.location) {
                        selectedLocation = searchParams.location;
                    }
                    areaSelectOptionRequest(
                        (result) =>
                            this.setState({ areaSelectOptions: result }),
                        (error) =>
                            this.setState({ error: "There was an error" }),
                    );
                    break;
                case "pag-ibig":
                    selectedTable = "pag-ibig";
                    getPagIbigEffectiveDateList((result) =>
                        this.setState({
                            effectiveDateList: result.data,
                        }),
                    );
                    if (match.params.id) {
                        selectedEffectiveDate = match.params.id;
                    } else {
                        selectedEffectiveDate = searchParams.date;
                    }
                    break;
                case "payscale":
                    selectedTable = "payscale";
                    areaSelectOptionRequest(
                        (result) =>
                            this.setState({ areaSelectOptions: result }),
                        (error) =>
                            this.setState({ error: "There was an error" }),
                    );
                    if (searchParams.location)
                        selectedLocation = searchParams.location;
                    if (searchParams.date)
                        selectedEffectiveDate = searchParams.date;
                    break;
                case "performance":
                    selectedTable = "performance";
                    break;
                case "phic":
                    selectedTable = "phic";
                    getPhicsEffectiveDateList((result) =>
                        this.setState({
                            effectiveDateList: result.data,
                        }),
                    );
                    if (match.params.id) {
                        selectedEffectiveDate = match.params.id;
                    } else {
                        selectedEffectiveDate = searchParams.date;
                    }
                    break;
                case "position":
                    selectedTable = "position";
                    break;
                case "sss":
                    selectedTable = "sss";
                    getSSSEffectiveDateList((result) =>
                        this.setState({
                            effectiveDateList: result.data,
                        }),
                    );
                    if (match.params.id) {
                        selectedEffectiveDate = match.params.id;
                    } else {
                        selectedEffectiveDate = searchParams.date;
                    }
                    break;
                case "income-tax":
                    selectedTable = "income-tax";
                    getIncomeTaxEffectiveDateList((result) =>
                        this.setState({
                            effectiveDateList: result.data,
                        }),
                    );
                    if (match.params.id) {
                        selectedEffectiveDate = match.params.id;
                    } else {
                        selectedEffectiveDate = searchParams.date;
                    }
                    break;
                default:
                    selectedTable = "";
            }
            this.setState(
                {
                    selectedTable: selectedTable,
                    selectedEmployee: selectedEmployee,
                    selectedLocation: selectedLocation,
                    selectedEffectiveDate: selectedEffectiveDate,
                    selectedAttendanceDate: selectedAttendanceDate,
                },
                () => {
                    if (selectedTable === "payscale" && selectedLocation) {
                        this.fetchPayscaleEffectiveDates(
                            selectedLocation,
                            selectedEffectiveDate,
                        );
                    }
                },
            );
        }
    }

    fetchPayscaleEffectiveDates = (
        selectedLocation,
        selectedEffectiveDate = this.state.selectedEffectiveDate,
    ) => {
        if (!selectedLocation) {
            this.setState({
                effectiveDateList: [],
                selectedEffectiveDate: "",
            });
            return;
        }

        getPayscaleEffectiveDateList(
            selectedLocation,
            (result) => {
                if (this.state.selectedLocation !== selectedLocation) return;

                const effectiveDateList = result.data || [];
                this.setState({
                    effectiveDateList,
                    selectedEffectiveDate:
                        selectedEffectiveDate &&
                        effectiveDateList.includes(selectedEffectiveDate)
                            ? selectedEffectiveDate
                            : "",
                });
            },
            () => {
                if (this.state.selectedLocation !== selectedLocation) return;

                this.setState({
                    effectiveDateList: [],
                    selectedEffectiveDate: "",
                });
            },
        );
    };

    handleActionSelect = (e) => {
        const { target } = e;
        const { name, value } = target;
        const {
            selectedTable = "",
            selectedLocation = "",
            selectedEffectiveDate = "",
            selectedAttendanceDate = "",
        } = this.state;

        // if (name === "selectedTable" && value === "attendance") {
        //     employeeSelectOptionRequest(
        //         (result) => this.setState({ employeeSelectOptions: result }),
        //         (error) => this.setState({ error: "There was an error" }),
        //     );
        // }

        if (name === "selectedTable" && value === "payscale") {
            areaSelectOptionRequest(
                (result) => this.setState({ areaSelectOptions: result }),
                (error) => this.setState({ error: "There was an error" }),
            );

            this.props.history.push(`/database/list/${value}`);
            this.setState({
                selectedTable: value,
                selectedLocation: "",
                selectedEffectiveDate: "",
                effectiveDateList: [],
            });
            return;
        }

        if (name === "selectedTable" && value === "holidays") {
            areaSelectOptionRequest(
                (result) => this.setState({ areaSelectOptions: result }),
                (error) => this.setState({ error: "There was an error" }),
            );
        }

        if (name === "selectedTable" && value === "sss") {
            getSSSEffectiveDateList((result) =>
                this.setState({
                    effectiveDateList: result.data,
                }),
            );
        }

        if (name === "selectedTable" && value === "phic") {
            getPhicsEffectiveDateList((result) =>
                this.setState({
                    effectiveDateList: result.data,
                }),
            );
        }

        if (name === "selectedTable" && value === "pag-ibig") {
            getPagIbigEffectiveDateList((result) =>
                this.setState({
                    effectiveDateList: result.data,
                }),
            );
        }

        if (name === "selectedTable" && value === "income-tax") {
            getIncomeTaxEffectiveDateList((result) =>
                this.setState({
                    effectiveDateList: result.data,
                }),
            );
        }

        if (name === "selectedLocation" && selectedTable === "payscale") {
            this.props.history.push(
                value
                    ? `/database/list/${selectedTable}?location=${value}`
                    : `/database/list/${selectedTable}`,
            );

            this.setState(
                {
                    selectedLocation: value,
                    selectedEffectiveDate: "",
                    effectiveDateList: [],
                },
                () => this.fetchPayscaleEffectiveDates(value, ""),
            );
        } else if (name === "selectedTable") {
            this.props.history.push(`/database/list/${value}`);
        } else if (name === "selectedEffectiveDate") {
            this.props.history.push(
                `/database/list/${selectedTable}?date=${value}&location=${selectedLocation}`,
            );
        } else if (name === "selectedEmployee") {
            this.props.history.push(
                `/database/list/${selectedTable}?date=${selectedAttendanceDate}&employee=${value}`,
            );
        } else {
            this.props.history.push(
                `/database/list/${selectedTable}?date=${selectedEffectiveDate}&location=${value}`,
            );
        }

        if (!(name === "selectedLocation" && selectedTable === "payscale")) {
            this.setState({
                [name]: value,
            });
        }
    };

    goToDetails = (collection, id) => {
        this.props.history.push(`/database/details/${collection}/${id}`);
    };

    goToEditForm = (collection, id) => {
        this.props.history.push(`/database/edit/${collection}/${id}`);
    };

    goToCreateForm = (collection) => {
        this.props.history.push(`/database/create/${collection}`);
    };

    goToCreateAttendanceForm = (employeeId) => {
        this.props.history.push(`/database/create/attendance/${employeeId}`);
    };

    handleAttendanceCSVInput = (input) => {
        this.setState({
            attendanceBulkLoading: true,
        });

        handleAttendanceCSVRequest(
            input,
            (result) =>
                this.setState({
                    attendanceBulkResult: result,
                    attendanceBulkSuccess: true,
                    attendanceBulkLoading: false,
                }),
            (error) =>
                this.setState({
                    attendanceBulkResult: null,
                    attendanceBulkSuccess: false,
                    attendanceBulkLoading: false,
                }),
        );
    };

    handleAttendanceCSVFileChange = (event) => {
        const file = event.target.files && event.target.files[0];

        if (!file) return;

        const reader = new FileReader();

        reader.onload = () => {
            try {
                const input = parseAttendanceCSV(reader.result || "");
                this.handleAttendanceCSVInput(input);
            } catch (error) {
                this.setState({
                    error: "There was an error reading the CSV file",
                    attendanceBulkResult: null,
                    attendanceBulkSuccess: false,
                    attendanceBulkLoading: false,
                });
            } finally {
                event.target.value = "";
            }
        };

        reader.onerror = () => {
            this.setState({
                error: "There was an error reading the CSV file",
                attendanceBulkResult: null,
                attendanceBulkSuccess: false,
                attendanceBulkLoading: false,
            });
        };

        reader.readAsText(file);
    };

    setAttendanceDate = (date) => {
        const { selectedTable = "", selectedEmployee = "" } = this.state;

        let dateFormated = moment(date).format("YYYY-MM-DD");

        this.props.history.push(
            `/database/list/${selectedTable}?date=${dateFormated}&employee=${selectedEmployee}`,
        );

        this.setState({
            selectedAttendanceDate: dateFormated,
        });
    };

    handleChange = (employeeValue) => {
        this.setState({
            selectedEmployee: employeeValue.value,
        });
    };

    render() {
        const {
            selectedTable,
            selectedEmployee,
            selectedLocation,
            selectedEffectiveDate,
            areaSelectOptions,
            attendanceBulkResult,
            attendanceBulkLoading,
            effectiveDateList,
            selectedAttendanceDate = "",
        } = this.state;

        console.log(areaSelectOptions, "areaSelectOptions");

        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            {/* SELECT */}
                            <FormGroup controlId="formControlsSelect">
                                <ControlLabel>Select Table</ControlLabel>
                                <FormControl
                                    onChange={this.handleActionSelect}
                                    componentClass="select"
                                    name="selectedTable"
                                    value={selectedTable}
                                >
                                    <option value="">Select</option>
                                    <option value="area">Area</option>
                                    <option value="attendance">
                                        Attendance
                                    </option>
                                    <option value="attendance-rule">
                                        Attendance Rule
                                    </option>
                                    <option value="attendance-csv">
                                        Attendance - CSV
                                    </option>
                                    <option value="company">Company</option>
                                    <option value="department">
                                        Department
                                    </option>
                                    <option value="employee-type">
                                        Employee Type
                                    </option>
                                    <option value="holidays">Holidays</option>
                                    <option value="income-tax">
                                        Income Tax
                                    </option>
                                    <option value="pag-ibig">Pag-ibig</option>
                                    <option value="pay-level">Pay Level</option>
                                    <option value="payscale">Payscale</option>
                                    {/*
                    TODO: Voltar performance quando tiver implementada
                    <option value="performance">Performance</option>
                  */}
                                    <option value="phic">PHIC</option>
                                    <option value="position">Position</option>
                                    <option value="sss">SSS</option>
                                </FormControl>
                            </FormGroup>
                        </Col>
                    </Row>
                    {selectedTable === "area" && (
                        <AreaTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "attendance-csv" &&
                        !attendanceBulkLoading &&
                        !attendanceBulkResult && (
                            <Row>
                                <Col md={12}>
                                    <label className="uploadButton noNewEntry">
                                        <i className="fas fa-file-import"></i>
                                        <input
                                            type="file"
                                            accept=".csv,text/csv"
                                            onChange={
                                                this
                                                    .handleAttendanceCSVFileChange
                                            }
                                        />
                                    </label>
                                </Col>
                            </Row>
                    )}
                    {selectedTable === "attendance-csv" &&
                        attendanceBulkLoading && (
                            <Row>
                                <Col md={12}>
                                    <div>Creating attendance instances...</div>
                                </Col>
                            </Row>
                        )}
                    {selectedTable === "attendance-csv" &&
                        !attendanceBulkLoading &&
                        attendanceBulkResult && (
                            <Row>
                                <Col md={12}>
                                    {attendanceBulkResult.length > 0 ? (
                                        <Table striped hover>
                                            <thead>
                                                <tr>
                                                    <th>Employee</th>
                                                    <th>Date</th>
                                                    <th>Time In</th>
                                                    <th>Break AM Start</th>
                                                    <th>Break AM End</th>
                                                    <th>Lunch Start</th>
                                                    <th>Lunch End</th>
                                                    <th>Break PM Start</th>
                                                    <th>Break PM End</th>
                                                    <th>Time Out</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attendanceBulkResult.map(
                                                    (instance) => {
                                                        return (
                                                            <tr
                                                                key={
                                                                    instance._id
                                                                }
                                                            >
                                                                <td>
                                                                    {getFullName(
                                                                        instance.employee,
                                                                    )}
                                                                </td>
                                                                <td>
                                                                    {instance.date
                                                                        ? moment
                                                                              .utc(
                                                                                  instance.date,
                                                                              )
                                                                              .format(
                                                                                  "MM/DD/YYYY",
                                                                              )
                                                                        : "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.timeIn ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.breakAmStart ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.breakAmEnd ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.lunchStart ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.lunchEnd ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.breakPmStart ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.breakPmEnd ||
                                                                        "-"}
                                                                </td>
                                                                <td>
                                                                    {instance.timeOut ||
                                                                        "-"}
                                                                </td>
                                                            </tr>
                                                        );
                                                    },
                                                )}
                                            </tbody>
                                        </Table>
                                    ) : (
                                        <div>
                                            There was an error creating
                                            attendance entries
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        )}
                    {selectedTable === "attendance" && (
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <ControlLabel>Select Employee</ControlLabel>
                                    <EmployeeAsyncSelect
                                        onChange={this.handleChange}
                                        placeholder="Start typing to see options..."
                                    />
                                    {/* <FormControl
                                        onChange={this.handleActionSelect}
                                        componentClass="select"
                                        name="selectedEmployee"
                                        value={selectedEmployee}
                                    >
                                        <option value="">Select</option>
                                        {employeeSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl> */}
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                    <ControlLabel>
                                        Select Month/Year
                                    </ControlLabel>
                                    <DatePicker
                                        dateFormat="MM/yyyy"
                                        timeFormat={false}
                                        showMonthYearPicker
                                        className="form-control"
                                        selected={
                                            selectedAttendanceDate
                                                ? moment(
                                                      selectedAttendanceDate,
                                                  ).toDate()
                                                : ""
                                        }
                                        onChange={this.setAttendanceDate}
                                        maxDate={new Date()}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {selectedTable === "attendance" &&
                        selectedEmployee &&
                        selectedAttendanceDate && (
                            <AttendanceTable
                                goToDetails={this.goToDetails}
                                goToEditForm={this.goToEditForm}
                                goToCreateForm={this.goToCreateAttendanceForm}
                                selectedEmployee={selectedEmployee}
                                selectedAttendanceDate={selectedAttendanceDate}
                            />
                        )}
                    {selectedTable === "attendance-rule" && (
                        <AttendanceRuleTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "pay-level" && (
                        <PayLevelTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "company" && (
                        <CompanyTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "department" && (
                        <DepartmentTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {(selectedTable === "payscale" || selectedTable === "holidays") && (
                        <Row>
                            <Col md={12}>
                                {/* SUB_SELECT */}
                                <FormGroup>
                                    <ControlLabel>Select Location</ControlLabel>
                                    <FormControl
                                        onChange={this.handleActionSelect}
                                        componentClass="select"
                                        name="selectedLocation"
                                        value={selectedLocation}
                                    >
                                        <option value="">Select</option>
                                        {areaSelectOptions.map((option) => {
                                            return (
                                                <option
                                                    key={option.value}
                                                    value={option.value}
                                                >
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {selectedTable === "holidays" && (
                        <>
                            <HolidaysTable
                                goToDetails={this.goToDetails}
                                goToEditForm={this.goToEditForm}
                                goToCreateForm={this.goToCreateForm}
                                selectedLocation={selectedLocation}
                            />
                        </>
                    )}
                    {selectedTable === "performance" && (
                        <PerformanceTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "position" && (
                        <PositionTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {(selectedTable === "sss" ||
                        selectedTable === "pag-ibig" ||
                        selectedTable === "phic" ||
                        selectedTable === "income-tax" ||
                        selectedTable === "payscale") && (
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <ControlLabel>
                                        Select Effective Date
                                    </ControlLabel>
                                    <FormControl
                                        onChange={this.handleActionSelect}
                                        componentClass="select"
                                        name="selectedEffectiveDate"
                                        value={selectedEffectiveDate}
                                    >
                                        <option value="">Select</option>
                                        {effectiveDateList.map((date) => {
                                            return (
                                                <option key={date} value={date}>
                                                    {moment(date).format(
                                                        "MM/DD/YYYY",
                                                    )}
                                                </option>
                                            );
                                        })}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    {selectedTable === "payscale" && selectedLocation && (
                        <PayscaleTable
                            selectedEffectiveDate={selectedEffectiveDate}
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                            selectedLocation={selectedLocation}
                        />
                    )}
                    {selectedTable === "pag-ibig" && (
                        <PagIbigTable
                            selectedEffectiveDate={selectedEffectiveDate}
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "phic" && (
                        <PHICTable
                            selectedEffectiveDate={selectedEffectiveDate}
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "sss" && (
                        <SSSTable
                            selectedEffectiveDate={selectedEffectiveDate}
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "employee-type" && (
                        <EmployeeTypeTable
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                    {selectedTable === "income-tax" && (
                        <IncomeTaxTable
                            selectedEffectiveDate={selectedEffectiveDate}
                            goToDetails={this.goToDetails}
                            goToEditForm={this.goToEditForm}
                            goToCreateForm={this.goToCreateForm}
                        />
                    )}
                </Grid>
            </div>
        );
    }
}

export default DatabaseList;
